/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * SalesforceServiceCloudForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DetailHeader, InputField } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
   margin-left: 35px;
 `;

export default function SalesforceServiceCloudForm({ isSaving, inherited, sidePanelUpdatePermissions }) {
  let salesForceServiceCloudUpdatePermission = sidePanelUpdatePermissions.salesForceServiceCloudUpdatePermission;
  let salesForceServiceCloudReadPermission = sidePanelUpdatePermissions.salesForceServiceCloudReadPermission;
  return (
    <Wrapper>
      {salesForceServiceCloudReadPermission == true &&
        <DetailWrapper open data-automation="salesforceServiceCloudPropertiesSVG">
          <WrappedDetailHeader text="Properties" />

          <InputField
            name="properties.username"
            label="Username *"
            componentType="input"
            inputType="text"
            data-automation="integrationsUsername"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.password"
            label="Password *"
            componentType="input"
            inputType="text"
            data-automation="integrationsPassword"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
            type="password"
          />


          <InputField
            name="properties.securityToken"
            label="Security Token *"
            componentType="input"
            inputType="text"
            data-automation="integrationsSecurityToken"
            type="password"
            autoComplete={'new-password'}
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.consumerKey"
            label="Consumer Key *"
            componentType="input"
            inputType="text"
            data-automation="integrationsConsumerKey"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.consumerSecret"
            label="Consumer Secret *"
            componentType="input"
            inputType="text"
            data-automation="integrationsConsumerSecret"
            type="password"
            autoComplete={'new-password'}
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.baseUrl"
            label="Base Url *"
            componentType="input"
            inputType="text"
            data-automation="integrationsBaseUrl"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.baseUrlTelephony"
            label="Base Url Telephony*"
            componentType="input"
            inputType="text"
            data-automation="integrationsBaseUrlTelephony"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.organisationId"
            label="Organisation Id*"
            componentType="input"
            inputType="text"
            data-automation="integrationsOrganisationId"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.callCenterName"
            label="Call Centre Name*"
            componentType="input"
            inputType="text"
            data-automation="integrationsCallCenterName"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
          <InputField
            name="properties.certificate"
            label="Certificate*"
            componentType="textarea"
            inputType="text"
            data-automation="integrationsCertificate"
            disabled={isSaving || inherited || !salesForceServiceCloudUpdatePermission}
          />
        </DetailWrapper>
      }
    </Wrapper>
  );
}

SalesforceServiceCloudForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
 // userHasUpdatePermission: PropTypes.bool,
  sidePanelUpdatePermissions: PropTypes.object
};
